import Promise from 'bluebird';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  MultiSelectorContextProvider,
  makeUseOptionsAsyncDataSource,
  makeUseSelectedOptionsAsyncDataSource,
} from '@bingads-webui-campaign-react/multi-selector';
import { loadAssociatedPageFeedsFactory, loadPageFeedsFactory } from './data-source';
import { PageFeedSelectorSectionImpl } from './page-feed-selector-section-impl';

const searchStartDelayMs = 300;
const defaultOptionsDisplayLimit = 50;
const defaultSelectedOptionsLimit = 20;

export const PageFeedSelectorSection = ({
  cid, aid, campaignId, onChange, onSelectedOptionsUpdate,
  loadPageFeedsFactory: loadPageFeedsFactoryFromProp,
  loadAssociatedPageFeedsFactory: loadAssociatedPageFeedsFactoryFromProp,
  optionsDisplayLimit, selectedOptionsLimit,
  customizedDescription, customizedSearchPlaceholder,
}) => {
  const loadPageFeeds = useMemo(() => loadPageFeedsFactoryFromProp(cid, aid), [loadPageFeedsFactoryFromProp, cid, aid]);
  const loadSelectedPageFeeds = useMemo(() => (campaignId ? loadAssociatedPageFeedsFactoryFromProp(cid, aid, campaignId) : () => Promise.delay(0, [])), [loadAssociatedPageFeedsFactoryFromProp, cid, aid, campaignId]);

  const useOptions = useMemo(() => makeUseOptionsAsyncDataSource(loadPageFeeds), [loadPageFeeds]);
  const useSelectedOptions = useMemo(() => makeUseSelectedOptionsAsyncDataSource(loadSelectedPageFeeds), [loadSelectedPageFeeds]);

  return (
    <MultiSelectorContextProvider
      useOptions={useOptions}
      useSelectedOptions={useSelectedOptions}
      selectedOptionsLimit={selectedOptionsLimit}
      optionsDisplayLimit={optionsDisplayLimit}
      onSelectedOptionsUpdate={onSelectedOptionsUpdate}
    >
      <PageFeedSelectorSectionImpl
        onChange={onChange}
        searchStartDelayMs={searchStartDelayMs}
        customizedDescription={customizedDescription}
        customizedSearchPlaceholder={customizedSearchPlaceholder}
      />
    </MultiSelectorContextProvider>
  );
};

PageFeedSelectorSection.propTypes = {
  loadPageFeedsFactory: PropTypes.func,
  loadAssociatedPageFeedsFactory: PropTypes.func,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number.isRequired,
  campaignId: PropTypes.number,
  onChange: PropTypes.func,
  onSelectedOptionsUpdate: PropTypes.func,
  optionsDisplayLimit: PropTypes.number,
  selectedOptionsLimit: PropTypes.number,
  customizedDescription: PropTypes.string,
  customizedSearchPlaceholder: PropTypes.string,
};
PageFeedSelectorSection.defaultProps = {
  loadPageFeedsFactory,
  loadAssociatedPageFeedsFactory,
  campaignId: undefined,
  onChange: undefined,
  onSelectedOptionsUpdate: undefined,
  optionsDisplayLimit: defaultOptionsDisplayLimit,
  selectedOptionsLimit: defaultSelectedOptionsLimit,
  customizedDescription: undefined,
  customizedSearchPlaceholder: undefined,
};
